export default __webpack_public_path__ + "static/media/icon_joy_type_b.2cf0f59c.png";